import { orderStatusOptionsNew, orderTypeOptions, productTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import OrderNumberCell from "components/table/columnComponents/OrderNumberCell"
import OrdersQuantity from "components/table/columnComponents/OrdersQuantity"
import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { StatusOfOrderNew } from "components/table/columnComponents/StatusOfOrderNew"

export const getVendorOrdersTableHeaderCells = (isFulfillChecked: boolean): UITypes.TableHeaderCell[] => {
  return [
    {
      title: "",
      name: "group_toggle",
      cellComponent: RowExpandToggle,
      size: "mini",
    },
    {
      title: "Order number",
      type: "search-number",
      name: "item_id",
      size: "middle",
      cellComponent: OrderNumberCell,
    },
    {
      title: "Status",
      type: isFulfillChecked ? "default" : "select",
      name: "item_status",
      options: orderStatusOptionsNew,
      cellComponent: StatusOfOrderNew,
    },
    {
      title: "Creation Date",
      type: "sort-date-range",
      name: "create_date",
      size: "small",
    },
    {
      title: "Shipping date",
      type: "date-range",
      name: "shipping_date",
      size: "small",
    },
    ...((isFulfillChecked
      ? [
          {
            title: "Fulfillment date",
            type: "date-range",
            name: "fulfillment_date",
            size: "middle",
          },
        ]
      : []) as UITypes.TableHeaderCell[]),
    {
      title: "Device",
      type: "select",
      name: "product_type",
      size: "middle",
      options: productTypeOptions,
    },
    {
      title: "Quantity",
      type: "search-number",
      name: "quantity",
      size: "middle",
      cellComponent: OrdersQuantity,
      cellComponentProps: {
        isVendor: true,
      },
    },
    {
      title: "Order type",
      type: "select",
      name: "item_type",
      size: "small",
      options: orderTypeOptions,
    },
    {
      title: "Warehouse",
      type: "search",
      name: "warehouse",
      size: "middle",
    },
    {
      title: "Company name",
      type: "sort-search",
      name: "company_name",
    },
    {
      title: "Contractor ID",
      type: "search",
      name: "contractor_id",
      size: "middle",
    },
    {
      title: "Phone number",
      type: "sort-search",
      name: "phone_number",
    },
    {
      title: "Email",
      type: "sort-search",
      name: "email",
    },
    {
      title: "Status Updated",
      type: "date-range",
      name: "status_updated",
    },
  ]
}
